// React and router imports
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Custom component
import EndpointManagementForm from "./components/EndpointManagementForm";

// @mui components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// API service
import { getEPMLicense } from "services/epmLicenseService";

function EditEPMLicense() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [license, setLicense] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const data = await getEPMLicense(id);
        setLicense(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching license:", err);
        setError("Failed to load license. Please try again.");
        setTimeout(() => {
          navigate("/services/epm");
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    fetchLicense();
  }, [id, navigate]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        {loading ? (
          <SoftBox textAlign="center" py={5}>
            <SoftTypography variant="body1">Loading license data...</SoftTypography>
          </SoftBox>
        ) : error ? (
          <SoftBox textAlign="center" py={5}>
            <SoftTypography variant="body1" color="error">
              {error}
            </SoftTypography>
          </SoftBox>
        ) : (
          <EndpointManagementForm license={license} isEdit={true} />
        )}
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditEPMLicense;